<div [formGroup]="dataForm" class="aside-content aside-width-3">
  <div class="aside-header fx-layout-row fx-layout-align-space-between-m fx-layout-align-center-x">
    <h3>Switch Company</h3>
  </div>
  <div>
    <mat-form-field>
      <mat-label>Company</mat-label>
      <mat-select formControlName="companyContactId">
        @for (lookup of userContactsLookupData; track lookup.id) {
          <mat-option [value]="lookup.id" [disabled]="!lookup.data">
            {{ lookup.text }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (companyContactId.touched && companyContactId.errors?.required) {
      <mat-error> Company is required </mat-error>
    }
  </div>
  <div class="fx-layout-row fx-gap-10">
    <button mat-raised-button (click)="switchCompany()" [disabled]="dataForm.status !== 'VALID'" color="primary"> Switch </button>
    <button mat-raised-button (click)="cancel()" color="primary"> Cancel </button>
  </div>
  <div>
    @if (isError) {
      <mat-error> {{switchErrorMessage}} </mat-error>
    }
  </div>
</div>